import { Deserializable } from '../protocols/deserializable';
import { VariableBenefitPaymentFrequencyEnum } from '../enum/shared/variable-benefit-payment-frequency.enum';

export class MemberVbAccountEstimatedAnnualPaymentTotal implements Deserializable {
  public estimatedAnnualTotal: number = 0;
  public nextYearEstimatedAnnualTotal: number | null = null;
  public monthlyMinimumPaymentAmount: number | null = null;
  public annualMinimumPaymentAmount: number | null = null;

  public onDeserialize(): void {}

  public minimumPaymentAmountFor(frequency: VariableBenefitPaymentFrequencyEnum): number | null {
    return frequency === VariableBenefitPaymentFrequencyEnum.Monthly
      ? this.monthlyMinimumPaymentAmount
      : this.annualMinimumPaymentAmount;
  }
}
